// extracted by mini-css-extract-plugin
export default {"root":"legal_root__JxvEz","section":"legal_section__gRzgA","text__privacy":"legal_text__privacy__J+Zdz"};